export default "__VITE_ASSET__d3771b0f__"